import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'report-type-modal',
    templateUrl: './report-type-modal.component.html',
    styleUrl: './report-type-modal.component.scss',
    standalone: false
})
export class ReportTypeModalComponent {
  
  constructor(
    public dialogRef: MatDialogRef<ReportTypeModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public mydata: any,
  ) {
    dialogRef.addPanelClass("something")
    dialogRef.updatePosition({
      top: "0px",
      right: "0px"
    })
    dialogRef.updateSize("540px", "100%")
  }
}